import type { Context } from 'react';
import { useContext, createContext } from 'react';
import fetch from 'cross-fetch';
import { getMappedCountryData } from './utils';
import type { AddressValidationContext, AddressValidationApiUtil, AddressValidationApiResponse } from '../@types';

export const addressValidateContext: Context<AddressValidationContext> = createContext<AddressValidationContext>({
    countries: {},
    setCountries: () => {},
    countryList: [],
});

export const useAddressValidateContext = () => useContext(addressValidateContext);

// todo: move this to @ynap/api-utils
export const addressValidation: AddressValidationApiUtil = async (params) => {
    try {
        const { config, countries, countryCode } = params;
        const { division } = config.head;
        const { baseUrl } = config.global.services.addressValidation;
        const url = `${baseUrl}api/address_validation/v1/${division}/countries/${countryCode}.json`;

        const response = await fetch(url);

        const responseJson: AddressValidationApiResponse = await response.json();

        if (response.status >= 400) {
            throw new Error(`addressValidation: Address Validation API error: ${response.url}`);
        }

        const countryData = responseJson.countries;
        return getMappedCountryData(countryData, countries);
    } catch (err) {
        console.log(err);
        throw err;
    }
};
